import secureLocalStorage from "react-secure-storage";
import {
  RESUME,
  resolveResumeTargetFromStatus,
} from "./resume-registry";

export { RESUME };

export const getStoredUser = () => {
  try {
    const raw = secureLocalStorage.getItem("user");
    const user = typeof raw === "string" ? JSON.parse(raw) : raw;
    return user || {};
  } catch {
    return {};
  }
};

export const getStoredUserDetails = () => getStoredUser()?.user_details || {};

export const getStoredStepStatus = () => getStoredUser()?.step_status || {};

// Merge server `step_status` into the stored session. Server wins per key.
export const persistStepStatus = (stepStatus) => {
  if (!stepStatus || typeof stepStatus !== "object") {
    return getStoredStepStatus();
  }
  const user = getStoredUser();
  const nextStatus = { ...(user.step_status || {}), ...stepStatus };
  secureLocalStorage.setItem(
    "user",
    JSON.stringify({ ...user, step_status: nextStatus }),
  );
  return nextStatus;
};

// App home is only for users who already have delivery or a datum asset.
export const canAccessDashboard = (details = getStoredUserDetails()) =>
  Boolean(details.has_delivered_order || details.has_datum_asset);

const CONTINUE_TARGETS = new Set([RESUME.procurement, RESUME.operations]);

// Most-complete step first (see RESUME_REGISTRY). Missing/empty `{}` → fuel.
export const resolveResumeTarget = (stepStatus = getStoredStepStatus()) =>
  resolveResumeTargetFromStatus(stepStatus);

export const isContinueResumeTarget = (target = resolveResumeTarget()) =>
  CONTINUE_TARGETS.has(target);

// Where a signed-in user without dashboard access should land.
export const resumeRedirect = () => {
  if (canAccessDashboard()) {
    return "/";
  }

  const target = resolveResumeTarget();
  if (isContinueResumeTarget(target)) {
    return "/onboarding/continue";
  }

  return { pathname: "/onboarding", state: { resume: target } };
};
